import { InAppMessageSchedule } from "../schedule/InAppMessageSchedule"
import { InAppMessageScheduleProcessor } from "../schedule/InAppMessageScheduleProcessor"
import { InAppMessageTrigger } from "./InAppMessageTrigger"

export class InAppMessageTriggerHandler {
  constructor(private readonly scheduleProcessor: InAppMessageScheduleProcessor) {}

  handle(trigger: InAppMessageTrigger) {
    const schedule = InAppMessageSchedule.create(trigger)
    const scheduleRequest = schedule.toRequest("TRIGGERED", trigger.event.timestamp)
    this.scheduleProcessor.process(scheduleRequest)
  }
}
